module.exports = __webpack_public_path__ + "static/media/hitomi.2b5f11fc.png";